<template>
  <div class="link_info_component">
    <div class="link_info_item" @click="weiXinClick" v-if="haveToken && qrCodeGroup !== ''">
      <img class="link_info_item_left" :src="iconWeiXin" width="16" height="16">
      <div class="link_info_item_right">
        微信
      </div>
    </div>

    <div class="link_info_item" @click="liuYanClick" v-if="haveToken && ($store.state?.vuex_app_user_info?.deny_feedback)">
      <img class="link_info_item_left" :src="iconLiuYan" width="16" height="16">
      <div class="link_info_item_right">
        留言
      </div>
    </div>

    <div class="link_info_item" @click="phoneClick" v-if="haveToken && ($store.state?.vuex_app_user_info?.hide_phone)">
      <img class="link_info_item_left" :src="iconPhone" width="16" height="16">
      <div class="link_info_item_right">
        电话
      </div>
    </div>
    <van-action-sheet
      v-model="phoneShow"
      :actions="actions"
      cancel-text="取消"
      :description="phone"
      close-on-click-action
      @select="onSelect"
      :overlay="true"
    />
  </div>
</template>

<script>
export default {
  name: 'LinkInfo',
  components: {},
  props: {
    test: {
      type: Number,
      default: 3
    }
  },
  data () {
    return {
      iconWeiXin: require('@/assets/icon/icon_weixin.png'),
      iconLiuYan: require('@/assets/icon/icon_liuyan.png'),
      iconPhone: require('@/assets/icon/icon_phone_green.png'),
      phoneShow: false,
      actions: [{ name: "呼叫" }],
    }
  },
  computed: {
    qrCodeGroup() {
      return this.$store.state?.vuex_app_user_info?.wechat_qr_code || "";
    },
    haveToken() {
      return this.$store.state?.vuex_app_token !== ''
    },
    phone() {
      // return this.$store.state?.vuex_app_user_info?.phone || "";
      if (this.$store.state?.vuex_app_user_info?.mobile_num){
        return this.$store.state?.vuex_app_user_info?.mobile_num
      } else {
        return this.$store.state?.vuex_app_user_info?.phone || '';
      }
    },
  },
  methods: {
    weiXinClick () {
      this.$emit('qunLiaoShow', true)
    },
    liuYanClick () {
      this.$emit('liuyanShow', true)
    },
    phoneClick () {
      if (!this.phone) {
        this.$myToast({
          type: 'fail',
          message: "暂无手机号",
        })
        return
      }
      // this.phoneShow = true;
      this.$emit('changePhoneShow', true)
    },
    onSelect(item) {
      // 默认情况下点击选项时不会自动收起
      // 可以通过 close-on-click-action 属性开启自动收起
      if (item.name === '呼叫') {
        this.aLink(`tel:${this.phone}`)
      }
    },
    aLink(href = "") {
      // 创建隐藏<a>标签进行下载
      const tempLink = document.createElement("a");
      tempLink.style.display = "none";
      tempLink.href = href;
      // tempLink.setAttribute("download", this.fileDialogData?.name);
      // if (typeof tempLink.download === "undefined") {
      //   tempLink.setAttribute("target", "_blank");
      // }
      document.body.appendChild(tempLink);
      tempLink.click();
      this.$nextTick(() => {
        document.body.removeChild(tempLink);
      });
    }
  }
}
</script>

<style lang="less" scoped>
  .link_info_component{
    // width: 212px;
    height: 23px;
    font-family: PingFangSC, PingFang SC, serif;

    position: absolute;
    top: 66px;
    left: 16px;
    z-index: 1; // 避免被输入条覆盖
    // padding: 0 10px;
    color: #fff;
    text-align: center;
    display: flex;
    font-size: 12px;
    line-height: 1;

    float: left;
    align-items: center;
    justify-content: space-between;
    .link_info_item{
      float: left;
      padding: 0 8px 0 8px;
      width: 44px;
      height: 23px;
      line-height: 23px;
      background: rgba(0, 0, 0, 0.3);
      border-radius: 12px;
      display: flex;
      align-items: center;
      margin-right: 5px;
    }
    .link_info_item_left{
      float: left;
      width: 16px;
      margin-right: 3px;

    }
    .link_info_item_right{
      float: left;
      width: 25px;
      font-weight: 400;
      font-size: 12px;
      color: #FFFFFF;
      line-height: 17px;
      text-align: left;
      font-style: normal;
    }
  }
</style>
